import * as types from './constants'

export const signIn = credentials => ({
  type: types.SIGN_IN,
  payload: credentials
})

export const signInSuccessful = user => ({
  type: types.SIGN_IN_SUCCESSFUL,
  payload: user
})

export const signInTemporarySuccess = user => ({
  type: types.SIGN_IN_TEMPORARY_SUCCESS,
  payload: user
})

export const signInFailure = error => ({
  type: types.SIGN_IN_FAILURE,
  payload: error
})

export const signUp = credentials => ({
  type: types.SIGN_UP,
  payload: credentials
})

export const signUpSuccessful = user => ({
  type: types.SIGN_UP_SUCCESSFUL,
  payload: user
})

export const signUpFailure = error => ({
  type: types.SIGN_UP_FAILURE,
  payload: error
})

export const updateEmail = ({ user, email }) => ({
  type: types.UPDATE_EMAIL,
  payload: { user, email }
})

export const updateEmailSuccessful = user => ({
  type: types.UPDATE_EMAIL_SUCCESSFUL,
  payload: user
})

export const updateEmailFailure = error => ({
  type: types.UPDATE_EMAIL_FAILURE,
  payload: error
})

export const logout = () => ({
  type: types.LOGOUT
})

export const getMyData = token => ({
  type: types.GET_MY_DATA,
  payload: token
})

export const getMyDataSuccessful = user => ({
  type: types.GET_MY_DATA_SUCCESSFUL,
  payload: user
})

export const getMyDataFailure = error => ({
  type: types.GET_MY_DATA_FAILURE,
  payload: error
})

export const setLang = payload => ({
  type: types.SET_LANG,
  payload
})

export const cleanAuth = () => ({
  type: types.CLEAN_AUTH
})
